import { Component } from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';

interface IProps {
  onClick?: (e?: any) => void;
  active?: boolean;
}

const TagElement = styled.div`
  cursor: default;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.vars.newColor.white};
  background-color: ${({ theme }) => theme.vars.color.pink};
  border-radius: 5px;
  transition: all 0.2s ease-in;
`;

const LabelElement = styled.div`
  padding: 10px;
`;

// The Tag component has an "active" prop as its currently designed to work
// with the existing MultiSelect keyboard nav support to highlight the tag
// button when left/right keys are pressed.  We may update this in the future
// to use focus but this is how it works for now.

const ButtonElement = styled.div`
  padding: 10px;
  color: ${({ active }: any) => (active ? 'white' : '#7f0236')};
  background-color: ${({ active }: any) => (active ? '#af0049' : 'auto')};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;

  &:hover {
    color: white;
    background-color: #af0049;
  }
` as any;

export class Tag extends Component<IProps> {
  public render() {
    return (
      <TagElement>
        <LabelElement>{this.props.children}</LabelElement>
        <ButtonElement onClick={this.props.onClick} active={this.props.active}>
          <Icon icon="times" />
        </ButtonElement>
      </TagElement>
    );
  }
}
